import type { TFunction } from "i18next";
import type { PromptPart } from "../../../api/threads/promptPartsApi";
import { spaced } from "../../workflows";

/** The selectors that read one library item, whose name titles the part. */
const ITEM_SELECTORS: ReadonlySet<string> = new Set(["item", "label_list"]);

/** The item a part was read from, for its title: the one version an item or label list selector read. */
export function partItemReference(part: PromptPart): string | null {
  return part.selectorKind !== null && ITEM_SELECTORS.has(part.selectorKind) ? (part.referencesRead[0] ?? null) : null;
}

/**
 * A part's title in the words the Workflow graph uses for what a step reads (P-E): the item it read by name, else
 * its selector's word, else its own name. An input part is titled by its input's card.
 */
export function promptPartTitle(part: PromptPart, itemName: string | null, t: TFunction): string {
  if (itemName !== null) return itemName;
  switch (part.selectorKind) {
    case "label_list":
    case "few_shot_examples":
    case "competency_questions":
      return t(`workflows.node.selectors.${part.selectorKind}`);
    case "subject_text":
      return t("workflows.details.entry");
    case "ontology_terms":
      return t("workflows.node.kinds.terms");
    case "earlier_results":
      return t("workflows.details.earlierResults");
    case null:
    default:
      return spaced(part.name);
  }
}
